import React, { useMemo } from 'react';
import {
  Row, Col, Select,
  Space,
} from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function TimeCardPreloadSettings({
  configProps,
  updateConfig,
  divisions,
  dataType,
}) {
  const customFields = useSelector((state) => state.timecards.customFields);

  const ourCustomFields = useMemo(() => (
    divisions?.map((divisionId) => {
      const {
        [divisionId]: { fields: timecardSections = [] } = {},
      } = customFields;

      return timecardSections
        .reduce((acc, section) => {
          const {
            fields: timecardFields,
            name: sectionName,
          } = section;

          return acc.concat(
            timecardFields?.filter((field) => field.selectedType === 'table' && field?.configProps?.dataType === dataType)
              ?.map((field) => ({
                label: `${sectionName} - ${field?.configProps?.title}`,
                value: field.id,
              })) ?? [],
          );
        }, []);
    }).flat() ?? []
  ), [customFields, divisions, dataType]);

  const updateValue = (key) => (value) => {
    updateConfig({ [key]: value });
  };

  return (
    <Space direction="vertical">
      <Row align="middle" gutter={10} style={{ marginLeft: 0 }}>
        <Col>
          From Timecards
        </Col>
        <Col>
          <Select
            options={ourCustomFields}
            style={{ width: 500 }}
            optionFilterProp="label"
            allowClear
            showSearch
            placeholder="Select Timecard Tables"
            mode="multiple"
            value={configProps.timecardPreloadTables}
            onChange={updateValue('timecardPreloadTables')}
          />
        </Col>
      </Row>
    </Space>
  );
}

/* eslint-disable react/forbid-prop-types */
TimeCardPreloadSettings.propTypes = {
  configProps: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  dataType: PropTypes.string.isRequired,
};

export default TimeCardPreloadSettings;
